"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireWildcard(require("react"));

var _BundlePage = require("./BundlePage");

var _PlanButton = _interopRequireDefault(require("./PlanButton"));

function SalesPlanButton(_ref) {
  var merchandiseId = _ref.merchandiseId,
      edition = _ref.edition;

  var _useContext = (0, _react.useContext)(_BundlePage.BundleContext),
      state = _useContext.state,
      setState = _useContext.setState;

  var salesPlanSelected = state.salesPlanSelected;

  var onSelectedChange = function onSelectedChange() {
    var updatedSelectedMerch = salesPlanSelected === merchandiseId ? null : merchandiseId;
    setState({
      salesPlanSelected: updatedSelectedMerch,
      salesUnits: 0
    });
  };

  return _react.default.createElement(_PlanButton.default, {
    edition: edition,
    merchandiseId: merchandiseId,
    selected: salesPlanSelected === merchandiseId,
    onSelectedChange: onSelectedChange
  });
}

var _default = SalesPlanButton;
exports.default = _default;
module.exports = exports.default;


//////////////////
// WEBPACK FOOTER
// ./js/components/bundle-page/SalesPlanButton.js
// module id = 703
// module chunks = 5 6